import ExamResult from "../../component/exam-result/Exam-Result";
import { useParams } from "react-router-dom";

const ExamResultView = () => {
  const { id } = useParams();
  return (
    <div className="EXAM_RESULT">
      <ExamResult ID={id} />
    </div>
  );
};

export default ExamResultView;
